export default {
  'CHANGE_COLOR' (state, payload) {
    state.cor = payload
  },
  'CHANGE_COLOR_SELECIONADO' (state, payload) {
    state.cor = payload
  },
  'CHANGE_LOGO' (state, payload) {
    state.isLog = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js